import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import twoscreen from './img/FirstThen/twoscreen.png';
import threescreen from './img/FirstThen/threescreen.png';
import fourscreen from './img/FirstThen/fourscreen.png';
import optionsone from './img/FirstThen/optionsone.png';
import optionstwo from './img/FirstThen/optionstwo.png';
import appstorebadge from './img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';


export const FirstThen = ({}) => {



	return (
		<div className="container-fluid appdesc">
<div className="row padrow">
 <div className="col-md-8 col-lg-8">
			 <h2>First Then 1 to 4</h2>
 </div>
 <div className="col-md-4 col-lg-2">
 <div className="badgecontainer">
		<a href='https://apps.apple.com/app/id1532250076'><img src={ appstorebadge } alt="Get in on App Store Badge" className="applebadge img-responsive d-block mx-auto badge"/></a>
</div>
 </div>
 <div className="col-md-4 col-lg-2">
 <div className="badgecontainer">
        <a href='https://play.google.com/store/apps/details?id=com.firstthen&hl=en&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' className="appimage img-responsive d-block mx-auto auditpic googlebadge"/></a>
</div>
 </div>

 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12 centervideo">
	<iframe width="560" height="315" src="https://www.youtube.com/embed/5W8hdrw6pl8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
 </div>
 </div>
	<div className="row padrow">
	<div className="col-md-12 col-lg-12 youtube">

	<a href='https://www.youtube.com/channel/UC4eN-brmGnxMLAYw3N5tA_g?view_as=subscriber?sub_confirmation=1'><b>Subscribe to YouTube Channel!</b>

	</a>
 </div>
 </div>
<div className="row padrow">
<div className="col-md-12 col-lg-12">
			This is a simple electronic version of the First Then board with user generated custom pictures.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={ twoscreen } alt="First Then 1 to 4 screen with two images" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
 <div className="row padrow">
<div className="col-md-12 col-lg-12">
			Users can choose between one to four steps.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src= {fourscreen } alt="First Then 1 to 4 screen with four images" className="appimage readypic img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
			 <div className="row padrow">
			 <div className="col-md-12 col-lg-12">
			 Users can also choose whether or not to display arrows, titles, and image descriptions.  Background colors are customizable.
 </div>
 </div>
 <div className="row padrow">
			 <div className="col-md-6 col-lg-6 text-center">


	<img src={ optionsone }alt="First Then 1 to 4 options screenshot 1" className="appimage readypic img-responsive img-thumbnail d-block mx-auto timerpic"/>
				</div>
	<div className="col-md-6 col-lg-6 text-center">

	 <img src={ optionstwo } alt="First Then 1 to 4 options screenshot 1" className="appimage readypic img-responsive img-thumbnail d-block mx-auto timerpic"/>
				</div>
			 </div>


			 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
 Please let us know if you experience any issues are have any suggstions at our feedback form <Link to="/feedback" >
 here
 </Link>.</div>
 </div>


</div>

			)


}
